import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import CategoriesTable from './CategoriesTable';

interface ICategoriesProps extends RouteComponentProps<{
    eshop: string;
    categoryId: string;
    parentCategoryId: string;
}> {

}

export default class Categories extends React.Component<ICategoriesProps> {

    public componentDidMount() {
        if ((this.props as any).onCollapse) {
            (this.props as any).onCollapse(false);
        }
    }

    render() {
        return (
            <div>
                <CategoriesTable 
                    domain={this.props.match.params.eshop}
                    categoryId={this.props.match.params.categoryId}
                    parentCategoryId={this.props.match.params.parentCategoryId}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/scenes/Categories/index.tsx